import React, { useRef } from "react";
import { Camera } from "lucide-react";

// Direct-to-camera capture button (opens rear camera on mobile, no upload option).
export default function CameraCaptureButton({ onCapture, testid, label, variant = "icon", disabled }) {
  const ref = useRef(null);
  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (file) await onCapture(file);
    if (ref.current) ref.current.value = "";
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/*" capture="environment" hidden onChange={handle} />
      <button
        type="button"
        data-testid={testid}
        disabled={disabled}
        onClick={() => ref.current?.click()}
        className={
          variant === "icon"
            ? "flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-primary/50 bg-primary/10 text-primary tap-scale hover:bg-primary/20 disabled:opacity-50"
            : "flex items-center gap-1.5 rounded-md border border-primary/50 bg-primary/10 px-2.5 py-1.5 text-xs font-semibold text-primary tap-scale hover:bg-primary/20 disabled:opacity-50"
        }
        title="Take photo"
      >
        <Camera className="h-4 w-4" />
        {variant !== "icon" && (label || "Photo")}
      </button>
    </>
  );
}
